<template>
  <Teleport to="#modals">
    <Modal @close="() => $emit('close')">
      <template #header-all>
        <BackButton :click="() => $emit('close')" type="button">
          Заместители
        </BackButton>
      </template>
      <template #content>
        <Loader v-if="isLoading" class="loader-default" />
        <div v-else class="form">
          <div class="form-grid">
            <div class="flex-c-sb">
              <h3 class="form-field-subtitle text-left">Я замещаю</h3>
            </div>
            <template v-if="meReplaceUsersCurrent?.length">
              <div
                class="form-field"
                v-for="user in meReplaceUsersCurrent"
                :key="user.id"
              >
                <p class="form-field-view">
                  {{ user.user_id_name }}
                </p>
                <p>
                  с {{ getLocalDate(user.date_from) }} по
                  {{ getLocalDate(user.date_to) }}
                </p>
                <p>
                  <button
                    class="btn btn-next btn-small"
                    @click="handleChangeUser(user)"
                  >
                    Войти
                  </button>
                </p>
              </div>
            </template>
            <template v-if="meReplaceUsersFuture?.length">
              <div
                class="form-field"
                v-for="user in meReplaceUsersFuture"
                :key="user.id"
              >
                <p class="form-field-view">
                  {{ user.user_id_name }}
                </p>
                <p>
                  с {{ getLocalDate(user.date_from) }} по
                  {{ getLocalDate(user.date_to) }}
                </p>
              </div>
            </template>
            <div
              class="form-field"
              v-if="
                !meReplaceUsersCurrent?.length && !meReplaceUsersFuture?.length
              "
            >
              <p class="form-field-view">Пусто</p>
            </div>
          </div>
          <div class="form-grid">
            <div class="flex-c-sb">
              <h3 class="form-field-subtitle text-left">Меня замещают</h3>
            </div>
            <template v-if="usersReplaceMeCurrent?.length">
              <div
                class="form-field"
                v-for="user in usersReplaceMeCurrent"
                :key="user.id"
              >
                <div class="form-field-view">
                  {{ user.user_vrio_name }}
                </div>
                <p>
                  с {{ getLocalDate(user.date_from) }} по
                  {{ getLocalDate(user.date_to) }}
                </p>
                <div class="btn-group-inline">
                  <button
                    class="btn btn-next btn-small"
                    @click="handleEditUser(user)"
                  >
                    <img src="@/assets/img/edit-icon.svg" alt="" />
                  </button>
                </div>
              </div>
            </template>
            <template v-if="usersReplaceMeFuture?.length">
              <div
                class="form-field"
                v-for="user in usersReplaceMeFuture"
                :key="user.id"
              >
                <div class="form-field-view">
                  {{ user.user_vrio_name }}
                </div>
                <p>
                  с {{ getLocalDate(user.date_from) }} по
                  {{ getLocalDate(user.date_to) }}
                </p>
                <div class="btn-group-inline">
                  <button
                    class="btn btn-next btn-small"
                    @click="handleEditUser(user)"
                  >
                    <img src="@/assets/img/edit-icon.svg" alt="" />
                  </button>
                  <button
                    class="btn btn-next btn-small btn-danger"
                    @click="handleDeleteUser(user)"
                  >
                    <img src="@/assets/img/trash-icon.svg" alt="" />
                  </button>
                </div>
              </div>
            </template>
            <div
              class="form-field"
              v-if="
                !usersReplaceMeCurrent?.length && !usersReplaceMeFuture?.length
              "
            >
              <p class="form-field-view">Пусто</p>
            </div>

            <div class="form-field">
              <button
                type="button"
                class="btn btn-next"
                @click="handleAddProxy"
              >
                Добавить заместителя
              </button>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </Teleport>
  <ProxyFormModal
    v-if="isProxyFormModalShow"
    :user="selectedUser"
    @close="isProxyFormModalShow = false"
    @submit="handleSubmit"
  />
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import Modal from '@/components/Modal.vue'
import BackButton from '@/components/BackButton.vue'
import ProxyFormModal from '@/components/modals/ProxyFormModal.vue'
import store from '@/store'
import Loader from '@/components/Loader.vue'
import {
  postVrioUser,
  getTokenVrioUser,
  deleteVrioUser,
  patchVrioUser,
} from '@/api/users'
import { getLocalDate } from '@/utils/helpers'
import useAuth from '@/utils/useAuth'

defineEmits(['close'])

const { setVrio } = useAuth()
const isProxyFormModalShow = ref(false)
const selectedUser = ref(null)
const isLoading = computed(() => store.state.vrio.isLoading)
const usersReplaceMeCurrent = computed(
  () => store.state.vrio.usersReplaceMeCurrent
)
const usersReplaceMeFuture = computed(
  () => store.state.vrio.usersReplaceMeFuture
)
const meReplaceUsersCurrent = computed(
  () => store.state.vrio.meReplaceUsersCurrent
)
const meReplaceUsersFuture = computed(
  () => store.state.vrio.meReplaceUsersFuture
)

onMounted(async () => {
  if (!isLoading.value) {
    await store.dispatch('vrio/fetchData')
  }
})

const handleAddProxy = async () => {
  isProxyFormModalShow.value = true
}

const handleSubmit = async (data) => {
  try {
    if (selectedUser.value) {
      await patchVrioUser(selectedUser.value?.id, data)
    } else {
      await postVrioUser(data)
    }
    await store.dispatch('vrio/fetchData')
    isProxyFormModalShow.value = false
  } catch (error) {
    store.dispatch('showError', error)
  } finally {
    selectedUser.value = null
  }
}

const handleChangeUser = async ({ id }) => {
  try {
    await getTokenVrioUser(id)
    setVrio(true)
    location.reload()
  } catch (error) {
    store.dispatch('showError', error)
  }
}

const handleEditUser = async (user) => {
  selectedUser.value = {
    ...user,
    user: {
      id: user.user_vrio,
      name: user.user_vrio_name,
      username: user.user_vrio_username,
    },
  }
  isProxyFormModalShow.value = true
}

const handleDeleteUser = async ({ id }) => {
  try {
    await deleteVrioUser(id)
    await store.dispatch('vrio/fetchData')
  } catch (error) {
    store.dispatch('showError', error)
  }
}
</script>

<style lang="scss" scoped>
.btn {
  img {
    height: 16px;
    display: block;
  }
}
</style>
